import script from "./AffiliateApply.vue?vue&type=script&setup=true&lang=js"
export * from "./AffiliateApply.vue?vue&type=script&setup=true&lang=js"

import "./AffiliateApply.vue?vue&type=style&index=0&id=be36e4f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be36e4f0"]])

export default __exports__